module.exports = require('./lib/patch')



//////////////////
// WEBPACK FOOTER
// ./~/react-hot-loader/patch.js
// module id = 160
// module chunks = 0